<template>
	<div>
		<div
			:class="
				viewQuestionBank ? 'view-sel-ques-container' : 'sel-ques-container'
			"
		>
			<div
				style="
          position: fixed;
          top: 20px;
          z-index: 1;
          backdrop-filter: blur(2px);
        "
				v-if="LoaderStatus"
			>
				<Spinner />
			</div>
			<div style="height: 80%">
				<div class="d-flex align-items-center">
					<div
						v-if="viewQuestionBank"
						class="minimize-right mt-2 ml-n3 pointer"
						@click="$emit('changeViewDataBank')"
					>
						<img src="../../assets/icons/Qpbuilder/minimizeright.svg" alt="" />
					</div>
					<div v-if="viewQuestionBank" class="sec-qb-text-view ml-3 mt-1">
						Select Questions from Question Bank
					</div>
				</div>
				<div
					class="d-flex align-items-center pl-3 pr-3 pt-3 pb-0 justify-content-between"
				>
					<div
						v-if="!viewQuestionBank"
						class="minimize-right ml-n4 pointer"
						@click="$emit('changeViewQuestionBank')"
					>
						<img src="../../assets/icons/Qpbuilder/minimizeleft.svg" alt="" />
					</div>

					<div class="sec-qb-text" v-if="!viewQuestionBank">Question Bank</div>

					<div class="ml-3 relativeclass search-width">
						<b-form-input
							placeholder="Search"
							type="search"
							v-model="searchname"
							@keyup="searchnameupdate()"
							class="search-ques"
						></b-form-input>
						<div class="cdb-searchicon">
							<img src="../../assets/searchicon.svg" alt="" />
						</div>
					</div>
					<div class="d-flex align-items-center">
						<div class="ml-3 relativeclass">
							<img
								v-b-popover.hover.top="'Sort'"
								src="../../assets/sorticon.svg"
								alt=""
								class="pointer"
								@click="
									(showsortcard = !showsortcard), (showfiltercard = false)
								"
								v-closable="{
									exclude: ['sortcard'],
									handler: 'hideSortFunction',
								}"
							/>

							<div v-if="showsortcard" ref="sortcard">
								<div class="databank-sortcard d-flex align-items-center p-1">
									<div
										@click="showsortcard = !showsortcard"
										class="xMarkCancel pointer"
									>
										<img src="../../assets/xmark.svg" alt="" />
									</div>
									<b-form-group class="sec-mcq-datacard jdtyperadio pt-2">
										<b-form-radio-group
											class="sort-radio-color pointer jdtyperadio"
											size="sm"
											v-model="sortoptions_selected"
											:options="sortoptions"
											@change="saveDatabankSort(), (showsortcard = false)"
											text-field="text"
											value-field="value"
										>
										</b-form-radio-group>
									</b-form-group>
								</div>
							</div>
						</div>
						<div
							class="sort-applied mb-3"
							v-if="sortoptions_selected != ''"
						></div>

						<div class="ml-3 position-relative" ref="filtershowicon">
							<img
								src="../../assets/filtericon.svg"
								v-b-popover.hover.top="'Filter'"
								alt=""
								class="pointer"
								@click="
									(showfiltercard = true),
										(showsortcard = false),
										(showdiffoptions = false)
								"
								v-closable="{
									exclude: ['filtercard'],
									handler: 'hideFilterFunction',
								}"
							/>

							<div v-if="showfiltercard" ref="filtercard">
								<div
									class="d-flex align-items-center relativeclass"
									:class="
										viewQuestionBank
											? 'view-databank-filtercard'
											: 'codetest-databank-filtercard'
									"
								>
									<div style="width: 100%">
										<div class="qb-fm-heading mb-2">
											<div
												@click="showfiltercard = false"
												class="xMarkCancel pointer"
											>
												<img src="../../assets/xmark.svg" alt="" />
											</div>
											Filter By
										</div>
										<div class="cdb-filter-overflow">
											<div class="qpc-left-card m-1">
												<div
													@click="viewDiff = !viewDiff"
													class="d-flex align-items-center justify-content-between pointer"
												>
													<span class="qpc-diff-text">Difficulty Levels</span>
													<span
														><img
															v-if="!viewDiff"
															src="../../assets/downarrow.svg"
															alt=""
														/>
														<img v-else src="../../assets/uparrow.svg" alt="" />
													</span>
												</div>
												<div
													v-if="viewDiff"
													class="bct-checkboxcontainer pointer jdtyperadio"
												>
													<b-form-group class="jdtyperadio bct-checboxtext m-1">
														<b-form-checkbox
															class="qb-dropdown-option-sing pointer m-1"
															v-for="option in difficultoptions"
															:key="option.value"
															:value="option.value"
															v-model="difficultylevel"
															>{{ option.text }}
														</b-form-checkbox>
													</b-form-group>
												</div>
											</div>
											<div class="qpc-left-card m-1 mt-3">
												<div
													@click="viewTags = !viewTags"
													class="d-flex align-items-center pointer justify-content-between"
												>
													<span class="qpc-diff-text">Tags</span>
													<span
														><img
															v-if="!viewTags"
															src="../../assets/downarrow.svg"
															alt=""
														/>
														<img v-else src="../../assets/uparrow.svg" alt="" />
													</span>
												</div>
												<div v-if="viewTags">
													<div class="mt-2 qpc-search-bar">
														<b-form-input
															placeholder="Search"
															class="search-ques"
															v-model="searchtag"
														></b-form-input>
													</div>
													<div
														class="qpc-checkbox-parent"
														v-if="roles.includes('PUSH_QUESTION')"
													>
														<b-form-checkbox
															class="mt-3 testconfig-checkbox"
															v-model="selectalltags"
															@change="checkSelectAlltags"
														>
															<div class="qpc-checkbox-text mt-1">
																Select All
															</div>
														</b-form-checkbox>
													</div>
													<div class="qpc-tags" @scroll="scroll">
														<b-form-group class="qpc-checkbox-parent ml-2">
															<b-form-checkbox
																v-for="option in allTags"
																:key="option"
																:value="option"
																v-model="Tags"
																name="role-check-button"
																class="qb-dropdown-option-sing pointer m-1"
															>
																{{ option }}
															</b-form-checkbox>
														</b-form-group>
														<div
															v-if="this.filterPageEnd != this.totalFilterData"
															style="margin: auto"
															class="d-flex justify-content-center mb-3"
														>
															<b-spinner small label="Loading..."></b-spinner>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div
											class="d-flex align-items-center justify-content-between mt-4"
										>
											<div
												class="clearfilter pointer mt-3"
												:class="clearFilterclass ? 'disabled-text' : 'pointer'"
												@click="clearFilterclass ? '' : clearfilter()"
											>
												Clear Filter
											</div>
											<div>
												<b-button
													class="addbtn"
													:disabled="clearFilterclass"
													@click="applyfilter(), (showfiltercard = false)"
												>
													Apply
												</b-button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="filter-count mb-3 mr-2" v-if="filtercount != 0">
							{{ filtercount }}
						</div>

						<div class="ml-3" v-if="roles.includes('PUSH_QUESTION')">
							<b-button
								variant=""
								:disabled="selectedQuestions.length == 0"
								@click="
									selectedQuestions.length == 0 ? '' : moveAllQuestions(),
										(searchname = '')
								"
								:class="
									selectedQuestions.length == 0
										? 'disabledbtn pl-2 pr-2'
										: 'addbtn pl-2 pr-2'
								"
								>Add to Section
							</b-button>
						</div>
					</div>
				</div>

				<div class="pl-2 pb-2 pr-2 pt-0 h-100">
					<template
						v-if="allquestions.length == 0 && this.LoaderStatus === false"
					>
						<div
							v-if="
								allquestions.length == 0 &&
									searchname == '' &&
									filtercount === 0 &&
									questionCount === 0
							"
							class="d-flex flex-column align-items-center justify-content-center h-100"
						>
							<div>
								<img src="../../assets/NocodingQuestion.svg" alt="" />
							</div>
							<div>
								<span class="d-flex flex-column mt-3"
									>No questions have been created yet.</span
								>
							</div>
						</div>

						<div
							v-if="
								allquestions.length == 0 &&
									searchname == '' &&
									(filtercount !== 0 || questionCount != 0)
							"
							class="d-flex flex-column align-items-center justify-content-center h-100"
						>
							<div>
								<img src="../../assets/searchnotfound.svg" alt="" />
							</div>
							<div>
								<span class="searchnotfound">No questions available.</span>
							</div>
						</div>
						<div
							v-if="searchname != '' && searchname != 'Loader'"
							class="d-flex flex-column align-items-center justify-content-center h-100"
						>
							<div>
								<img src="../../assets/searchnotfound.svg" alt="" />
							</div>
							<div>
								<span class="searchnotfound"
									>No matching results for
									<span class="searchtext text-break">
										"{{ searchname }}"
									</span>
								</span>
							</div>
						</div>
					</template>

					<template v-if="allquestions.length > 0">
						<div
							class="d-flex justify-content-between pt-1 mt-1"
							v-if="roles.includes('PUSH_QUESTION')"
						>
							<div
								class="d-flex align-items-center p-1 mcq-custom-zindex"
								style="margin-left: 22px"
							>
								<b-form-checkbox
									class="sec-checboxtext"
									name="mcqmtfcheck"
									v-model="selectall"
									@change="selectAll()"
								/>
								<label class="selectall pt-3"> Select All Questions</label>
							</div>
							<label class="selectall pt-3 mr-4">
								Total Selected Questions: {{ this.selectedQuestions.length }}
							</label>
						</div>

						<div class="view-over-page" id="codeQuestionsScroll">
							<div
								class="codingtestcards"
								v-for="(question, index) in allquestions"
								:key="question.questionKey"
								:id="question.questionKey"
							>
								<div
									class="p-3"
									:class="
										selectedQuestions.includes(question.questionKey)
											? 'selquessubcontainer'
											: viewQuestionBank
											? 'dbquesfullcards'
											: 'dbquescards'
									"
								>
									<div
										class="d-flex align-items-center justify-content-between"
										style="height: 60px"
									>
										<div class="d-flex align-items-center">
											<div
												class="mcq-custom-zindex"
												v-if="roles.includes('PUSH_QUESTION')"
											>
												<b-form-checkbox
													class="sec-checboxtext mr-2"
													name="mcqmtfcheck"
													:value="question.questionKey"
													v-model="selectedQuestions"
													@change="deselect()"
												>
												</b-form-checkbox>
											</div>

											<div class="db-mcqtophead ml-3">
												Difficulty Level - {{ question.difficultyLevel }}
											</div>
											<div class="db-mcqtophead ml-3">
												{{ question.marks }} Marks
											</div>
										</div>

										<b-button
											class="addbtn mr-n2"
											v-show="
												selectedQuestions.length == 0 &&
													roles.includes('PUSH_QUESTION')
											"
											@click="
												addQuestionFromDB(
													question,
													question['questionKey'].slice(0, 4)
												)
											"
											>Add Question</b-button
										>
									</div>
									<div
										class="ml-3 align-items-center pointer"
										style="width: 95%; padding: 5px 15px 5px 0px"
									>
										<div class="qpc-totalQuesnum">
											Q{{ index + 1 }}.

											<span class="qpc-totalQuesnum ml-1">{{
												question.title
											}}</span>
										</div>

										<div class="sec-ques-style relativeclass">
											<template>
												<div>
													<div
														class="topicDescBreak ml-1"
														v-html-safe="question.question"
													></div>
													Tags :
													<div
														class="mt-2"
														v-for="(tag, k) in question.questionTags"
														:key="k"
													>
														{{ tag }}
													</div>
													<div class="d-flex justify-content-between mt-3">
														<div class="db-mcqtophead">
															Category :
															<b
																><span v-html-safe="question.category"></span
															></b>
														</div>

														<div @click="viewMore(question.questionKey)">
															<img
																v-if="
																	currentOpenQuestion != question.questionKey
																"
																src="../../assets/preview eye.svg"
																alt=""
																class="pointer"
																style="margin-right: 5px; margin-left: 4px"
															/>
															<img
																v-else
																src="../../assets/notviewicons.svg"
																alt=""
																class="pointer"
																style="margin-right: 5px; margin-left: 4px"
															/>
															<span>View More</span>
														</div>
													</div>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
							<hr />
							<div
								class="text-center"
								v-if="
									!viewQuestionBank &&
										filtercount == 0 &&
										searchname == '' &&
										allquestions.length > 10
								"
							>
								<b-button
									class="addbtn"
									@click="
										$emit('changeViewQuestionBank'),
											allquestions.length > 50
												? (currentPage = 2)
												: (currentPage = 1),
											getcodingquestions(),
											(addMulti = true)
									"
									>Show More Questions</b-button
								>
							</div>
						</div>
					</template>
				</div>
			</div>
			<template v-if="allquestions.length != 0">
				<div
					v-if="viewQuestionBank"
					class="qbpaginaTion d-flex justify-content-between align-items-center page-alignment p-1"
				>
					<div class="d-flex">
						<span class="qb-gotopage-text p-1">Go to page</span>
						<b-form-input
							type="text"
							class="qb-pagination-num mr-1"
							v-model.trim="goToPage"
							@keyup.enter="
								goToPage === null || goToPage == '' || iscontainsNumber
									? ''
									: goToPageNo(goToPage)
							"
						></b-form-input>
						<b-button
							:disabled="
								goToPage === null || goToPage == '' || iscontainsNumber
							"
							class="qb-pagination-addbtn"
							@click="goToPageNo(goToPage)"
						>
							<span><img src="../../assets/whiterightarrow.svg" alt=""/></span>
						</b-button>
					</div>

					<div class="pagination">
						<b-pagination
							v-model.number="currentPage"
							:total-rows="total"
							:per-page="question_count"
							@input="goToPageNum()"
							align="center"
							first-number
							last-number
						>
							<template #prev-text
								><span><img src="../../assets/leftvector.svg" alt="" /> </span
							></template>
							<template #next-text
								><span><img src="../../assets/rightarrow.svg" alt=""/></span
							></template>
						</b-pagination>
					</div>
					<div class="qb-gotopage-text mr-2">
						Results :<span v-if="pageStart > total">0</span
						><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
						<span class="pl-1"></span> of <span class="pr-1"></span>{{ total }}
					</div>
				</div>
			</template>
		</div>

		<b-modal
			size="lg"
			id="ViewQuesdatabank"
			centered
			hide-footer
			hide-header
			@hidden="closeModal"
		>
			<div class="qpc-modal-head-text">View Question</div>
			<div @click="closeModal" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="qpc-modal-card">
				<div class="d-flex align-items-center mt-3 ml-4">
					<div class="qpc-small-box">
						Difficulty Level: {{ question.difficultyLevel }}
					</div>
					<div class="qpc-small-box">Marks: {{ question.marks }}</div>
					<div class="qpc-small-box">
						Category : <b>{{ question.category }}</b>
					</div>
				</div>
				<div class="qpc-tags-text mt-3 ml-4">
					Tags :
					<div v-for="(tag, k) in question.questionTags" :key="k">
						{{ tag }}<span v-if="k < question.questionTags.length - 1">,</span>
					</div>
				</div>
				<div class="mt-3">
					<span class="qpc-totalQuesnum">Q. &nbsp;</span
					><span class="qpc-totalQuesnum ml-1">{{ question.title }}</span>
				</div>
				<div
					class="qpc-full-ques ml-4 mr-4 mt-3"
					v-html-safe="question.question"
				></div>
				<div class="qpc-left-card mt-3 ml-4 mr-4">
					<span class="qpc-modal-card-text">Constraints:</span>
					<div
						class="mt-3 qpc-tags-text"
						v-html-safe="question.constraints"
					></div>
				</div>
				<div class="qpc-left-card mt-2 ml-4 mr-4">
					<span class="qpc-modal-card-text">Sample</span>
					<div class="p-3 qpc-tags-text d-flex flex-column">
						Input: <span v-html-safe="question.sampleInput"> </span>
						Output:
						<span v-html-safe="question.sampleOutput"> </span>
					</div>
				</div>
				<template v-if="question.testCases.length > 0">
					<div class="qpc-left-card mt-2 ml-4 mr-4">
						<span class="bct-preview-head">Test Cases</span>
						<div class="d-flex">
							<div class="bct-many-testCase-left" style="width: 25%">
								<!--********************   SELECTED TEST CASE CLASS  *********************-->

								<!--********************   UNSELECTED TEST CASE  CLASS *********************-->

								<div
									v-for="(tc, k) in question.testCases"
									:key="k"
									@click="selecttestcase(k)"
									:class="
										viewtestcase == k
											? 'p-2 bct-many-testCase-sel-text'
											: 'p-2 bct-many-testCase-text pointer'
									"
								>
									Test Case {{ k + 1 }}
								</div>
							</div>
							<div class="bct-many-testCase-right" style="width: 75%">
								<div class="bct-TC-card p-3 m-2">
									<span class="bct-preview-head">Input: </span>

									<div class="bct-card-subtext mt-2">
										{{ question.testCases[viewtestcase].inputValue }}
									</div>
								</div>
								<div class="bct-TC-card p-3 m-2">
									<span class="bct-preview-head">Output: </span>
									<div class="bct-card-subtext mt-2">
										{{ question.testCases[viewtestcase].outputValue }}
									</div>
								</div>
								<div class="bct-TC-card p-3 m-2">
									<span class="bct-preview-head"
										>Visible:
										<div class="bct-card-subtext mt-2">
											{{ question.testCases[viewtestcase].visible }}
										</div></span
									>
								</div>
							</div>
						</div>
					</div>
				</template>
			</div>
		</b-modal>
	</div>
</template>
<script>
import {
	getcodingquestions,
	getcodingquestion,
	getquestiontagsct,
	moveDataBankQuesData,
} from "../../utils/apiFunctions.js";
import { mapGetters } from "vuex";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import successToast from "../mixin/toast.js";
import errorToast from "../mixin/toast";

export default {
	name: "Codetestdatabank",
	components: {
		Spinner,
	},
	props: {
		viewQuestionBank: Boolean,
		movestatus: Boolean,
		questionDeleted: Boolean,
		questionCount: Number,
	},
	mixins: [successToast, errorToast],

	data() {
		return {
			// Number
			filterPageEnd: null,
			totalFilterData: null,
			page: 0,
			filtercount: 0,
			currentPage: 1,
			total: 0,
			question_count: 50,
			testCasescount: 5,
			loopVar: 5,
			viewtestcase: 0,
			pageStart: null,
			pageEnd: null,
			nextPage: null,
			goToPage: null,
			totalPages: null,

			// String
			searchtag: "",
			sortoptions_selected: "",
			searchname: "",
			currentOpenQuestion: "",

			alltags: [],
			difficultylevel: [],
			Tags: [],

			//BOOLEAN
			LoaderStatus: false,
			selectalltags: false,
			viewTags: false,
			viewDiff: false,
			showfiltercard: false,
			addMulti: false,
			selectall: false,
			showsortcard: false,
			openmodal: false,

			//ARRAYS
			selectedQuestions: [],
			allquestions: [],

			// OBJECTS
			question: {
				testCases: [
					{
						inputValue: "",
						outputValue: "",
						visible: "",
					},
				],
			},

			//ARRAY OF OBJECTS
			sortoptions: [
				{ text: "No Sort", value: "" },
				{ text: "Created Date (Asc)", value: "1" },
				{ text: "Created Date (Desc)", value: "2" },
				{ text: "Marks (Asc)", value: "3" },
				{ text: "Marks (Desc)", value: "4" },
				{ text: "Title (Asc)", value: "5" },
				{ text: "Title (Desc)", value: "6" },
			],
			difficultoptions: [
				{ text: "Difficulty level 1", value: 1 },
				{ text: "Difficulty level 2", value: 2 },
				{ text: "Difficulty level 3", value: 3 },
				{ text: "Difficulty level 4", value: 4 },
				{ text: "Difficulty level 5", value: 5 },
			],
		};
	},

	created() {
		this.LoaderStatus = true;
		this.getcodingquestions();
		this.getTags();
	},
	watch: {
		selectedSection() {
			this.getcodingquestions();
		},
		searchtag() {
			this.getTags();
		},
		movestatus(newValue, oldValue) {
			if (newValue != oldValue) {
				this.filterdetails();
			}
		},
		questionDeleted(newValue) {
			if (newValue == true) {
				this.getcodingquestions();
			}
		},
	},

	computed: {
		clearFilterclass() {
			return (
				this.selectalltags == "" &&
				this.Tags == "" &&
				this.difficultylevel == ""
			);
		},
		isContainsNumber() {
			return !/^\d+$/.test(this.goToPage);
		},
		...mapGetters("sectionVUEX", {
			selectedSection: "getSelectedSection",
		}),
		...mapGetters(["roles"]),
	},
	methods: {
		//Lazy loading in filter for tags
		scroll(e) {
			const { target } = e;
			if (
				Math.ceil(target.scrollTop) >=
				target.scrollHeight - target.offsetHeight
			) {
				if (this.checkbetween(this.filterPageEnd, 0, this.totalFilterData)) {
					this.page++;

					this.getTags();
				}
			}
		},

		checkbetween(x, min, max) {
			return x >= min && x <= max;
		},
		filterdetails() {
			if (this.movestatus) {
				for (let j in this.finalQBDetails) {
					for (let i in this.selectedQuestions) {
						if (
							this.selectedQuestions[i].questionKey ==
							this.finalQBDetails[j].questionKey
						) {
							this.finalQBDetails.splice(j, 1);
						}
					}
				}
				this.selectedQuestions = [];
			}
		},
		async moveAllQuestions() {
			// Initialize an array to store unique question keys
			let queskey = [];

			// Iterate over each selected question
			this.selectedQuestions.forEach((element) => {
				// Check if the question key is not already included in queskey array
				if (!queskey.includes(element.slice(0, 4))) {
					// Add the first four characters of the question key to queskey array
					queskey.push(element.slice(0, 4));
				}
			});

			// Create a payload object with testID, sectionID, questionKey, and questionType
			let payload = {
				testID: this.selectedSection.testID,
				sectionID: this.selectedSection.sectionID,
				questionKey: this.selectedQuestions,
				questionType: queskey,
			};

			// Make an asynchronous request to moveDataBankQuesData function with payload
			const res = await moveDataBankQuesData(payload);

			// Check if the response status is 200 (indicating success)
			if (res.status == 200) {
				// Update the currentPage variable to 1
				this.currentPage = 1;

				// Display a success toast message with the number of questions added
				this.successToast(
					this.selectedQuestions.length +
						" Questions added to section successfully"
				);

				// Emit a custom event to change the view in DataBank component
				this.$emit("changeViewDataBank");

				// Emit a custom event to indicate that a question has been added
				this.$emit("question-added");

				// Call the getcodingquestions function to update the questions list
				// this.getcodingquestions();
			}

			// Clear the selectedQuestions array
			this.selectedQuestions = [];

			// Set addMulti flag to false
			this.addMulti = false;

			// Force a component update
			this.$forceUpdate();
		},
		async addQuestionFromDB(ques, questype) {
			try {
				// Create a payload object with testID, sectionID, questionKey, and questionType
				let payload = {
					testID: this.selectedSection.testID,
					sectionID: this.selectedSection.sectionID,
					questionKey: [ques.questionKey],
					questionType: [questype],
				};

				// Make an asynchronous request to moveDataBankQuesData function with payload
				const res = await moveDataBankQuesData(payload);

				// Check if the response status is 200 (indicating success)
				if (res.status == 200) {
					// Clear the selectedQuestions array
					this.selectedQuestions = [];

					// Emit a custom event to indicate that a question has been added
					this.$emit("question-added");

					// Call the getcodingquestions function to update the questions list
					// await this.getcodingquestions();

					// Execute the successToast function after the DOM has been updated
					this.$nextTick(() => {
						this.successToast("Question added to section successfully!");
					});
				}
			} catch (error) {
				// Display an error toast message
				this.errorToast("Something went wrong!");

				// Throw an error with the specific status
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		clearfilter() {
			// Clear the difficultylevel array
			this.difficultylevel = [];

			// Reset the searchtag and selectalltags variables
			this.searchtag = "";
			this.selectalltags = false;

			// Clear the Tags array
			this.Tags = [];

			// Check if filtercount is not 0
			if (this.filtercount != 0) {
				// Call the getcodingquestions function to update the questions list
				this.getcodingquestions();
			}
			// Reset the filtercount variable
			this.filtercount = 0;
		},
		applyfilter() {
			// Reset the filtercount variable
			this.filtercount = 0;

			// Check if the searchtag is not empty
			if (this.searchtag.length != 0) {
				// Set the searchtag variable to true
				this.searchtag = true;

				// Increment the filtercount
				this.filtercount++;
			}

			// Check if the Tags array is not empty
			if (this.Tags.length != 0) {
				// Increment the filtercount
				this.filtercount++;
			}

			// Check if the difficultylevel array is not empty
			if (this.difficultylevel.length != 0) {
				// Increment the filtercount
				this.filtercount++;
			}
			// Call the getcodingquestions function to update the questions list
			this.getcodingquestions();
		},
		async getTags() {
			// Create a payload object with page, count, and searchQuery
			let payload = {
				page: this.page,
				count: 10,
				searchQuery: this.searchtag,
			};

			// Make an asynchronous request to getquestiontagsct function with payload
			const res = await getquestiontagsct(payload);

			// Check if the response status is 200 (indicating success)
			if (res.status == 200) {
				// Check if the returned data has tags
				if (res.data.data.data.length != 0) {
					// Check if it's the first page of data
					if (this.page == 0) {
						// Set the allTags array to the retrieved tags
						this.allTags = res.data.data.data;
					} else {
						// Append the retrieved tags to the existing allTags array
						this.allTags = [...this.allTags, ...res.data.data.data];
					}
				}

				// Update the totalFilterData and filterPageEnd variables
				this.totalFilterData = res.data.data.total;
				this.filterPageEnd = res.data.data.pageEnd;
			}
		},
		checkSelectAlltags() {
			if (arguments[0]) {
				this.Tags = [...this.allTags];
			} else {
				this.Tags = [];
			}
		},
		goToPageNum() {
			this.LoaderStatus = true;
			this.getcodingquestions();
		},
		goToPageNo(index) {
			this.LoaderStatus = true;
			this.currentPage = Math.min(Math.max(1, index), this.totalPages);
			this.goToPage = null;
			this.getcodingquestions();
		},
		deselect() {
			// Set selectall to false
			this.selectall = false;

			// Check if allquestions array contains all the selectedQuestions
			const containsAll = this.allquestions.every((element) => {
				return this.selectedQuestions.includes(element.questionKey);
			});

			// If all questions are selected, set selectall to true
			if (containsAll) {
				this.selectall = true;
			}
		},
		checkSelectAll() {
			// Initialize isSelectedAll as true
			let isSelectedAll = true;

			// Iterate over each record in the allquestions array
			for (const record of this.allquestions) {
				// Check if the questionKey of the record is not included in selectedQuestions array
				if (
					this.selectedQuestions.filter((value) => value === record.questionKey)
						.length === 0
				) {
					// If any question is not selected, set isSelectedAll to false
					isSelectedAll = false;
				}
			}

			// Set selectall to the value of isSelectedAll
			this.selectall = isSelectedAll;
		},

		selectAll() {
			if (this.selectall) {
				// If selectall is true, select all questions

				// Iterate over each element in the allquestions array
				for (let i in this.allquestions) {
					// Check if the questionKey of the element is not already in selectedQuestions array
					if (
						this.selectedQuestions.filter(
							(value) => value == this.allquestions[i].questionKey
						).length === 0
					) {
						// If the question is not already selected, add it to selectedQuestions array
						this.selectedQuestions.push(this.allquestions[i].questionKey);
					}
				}
			} else {
				// If selectall is false, deselect all questions

				// Iterate over each element in the allquestions array
				for (let j in this.allquestions) {
					// Check if the questionKey of the element is already in selectedQuestions array
					if (
						this.selectedQuestions.filter(
							(value) => value == this.allquestions[j].questionKey
						).length > 0
					) {
						// If the question is selected, remove it from selectedQuestions array
						this.selectedQuestions.splice(
							this.selectedQuestions.indexOf(this.allquestions[j].questionKey),
							1
						);
					}
				}
			}
		},
		hideSortFunction() {
			this.showsortcard = false;
		},
		// Sorting
		async saveDatabankSort() {
			if (this.sortoptions_selected == "1") {
				this.sortColumn = "difficultyLevel";
				this.sortOrder = true;
			} else if (this.sortoptions_selected == "2") {
				this.sortColumn = "difficultyLevel";
				this.sortOrder = false;
			} else if (this.sortoptions_selected == "3") {
				this.sortColumn = "marks";
				this.sortOrder = true;
			} else if (this.sortoptions_selected == "4") {
				this.sortColumn = "marks";
				this.sortOrder = false;
			} else if (this.sortoptions_selected == " 5") {
				this.sortColumn = "title";
				this.sortOrder = true;
			} else if (this.sortoptions_selected == "6") {
				this.sortColumn = "title";
				this.sortOrder = false;
			} else {
				this.sortColumn = "";
			}
			this.getcodingquestions();
		},
		// Clear search
		clearSearch() {
			this.LoaderStatus = true;
			this.searchname = "";
			this.getcodingquestions();
		},

		searchnameupdate() {
			this.LoaderStatus = true;
			this.getcodingquestions();
		},
		selecttestcase(index) {
			this.viewtestcase = index;
		},

		// View Question in Detail
		async viewMore(key) {
			// Make an asynchronous request to getcodingquestion function with the provided key
			const res = await getcodingquestion(key);
			this.question = res.data.data;

			// Reset the viewtestcase variable to 0
			this.viewtestcase = 0;

			this.currentOpenQuestion = key;
			// Show the "ViewQuesdatabank" modal using Bootstrap Vue modal component
			this.$bvModal.show("ViewQuesdatabank");
		},

		closeModal() {
			this.$bvModal.hide("ViewQuesdatabank");
			this.currentOpenQuestion = "";
		},

		// getting all the coding questions
		async getcodingquestions() {
			try {
				let payload = {
					page: this.currentPage - 1,
					count: this.question_count,
					searchQuery: this.searchname,

					sortBy: {
						column: this.sortColumn,
						order: this.sortOrder,
					},
					filters: {
						category: "",
						difficultyLevel: this.difficultylevel,
						questionTags: this.Tags,
						addToDatabank: false,
						addToPublic: false,
						status: 2,
						active: true,
						sectionID: this.selectedSection.sectionID,
					},
				};
				const res = await getcodingquestions(payload);
				if (res.status == 200) {
					this.allquestions = res.data.data.data;
					this.pageStart = res.data.data.pageStart;
					this.nextPage = res.data.data.nextPage;
					this.total = res.data.data.total;
					this.pageEnd = res.data.data.pageEnd;
					this.checkSelectAll();
					this.totalPages = Math.ceil(
						parseInt(this.total) / parseInt(this.question_count)
					);
					if (document.getElementById("codeQuestionsScroll") != null) {
						this.$nextTick(() => {
							const scrollContainer = document.getElementById(
								"codeQuestionsScroll"
							);
							scrollContainer.scrollTo({
								top: 0,
								left: 0,
								behavior: "smooth",
							});
						});
					}
					this.LoaderStatus = false;
					this.$emit("questionsFetched");
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
	},
};
</script>

<style scoped>
.qpc-modal-card-text {
	font-weight: 500;
	font-size: 13px;
	color: #333333;
}
.qpc-totalQuestext {
	font-weight: 500;
	font-size: 14px;
	color: #1d262d;
}
.qpc-tags {
	height: 140px;
	overflow: auto;
}
.qpc-totalQuesnum {
	font-weight: 600;
	font-size: 16px;
	color: #333333;
}
.qpc-left-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	padding: 15px;
}
.codingtestcards {
	background: #ffffff;
	box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
	border-radius: 10px;
	padding: 10px;
}
.scrolldatabank {
	overflow-x: hidden;
	overflow-y: hidden;
}

.radio {
	color: #72738e;
	font-size: 11px;
	padding-top: 4px;
	margin-left: 1px;
	margin-right: 1px;
	padding-right: 0px;
}

.selectall {
	color: #696969;
	padding: 5px;
	font-family: "Poppins", sans-serif;
	font-style: Regular;
	font-size: 12px;

	vertical-align: top;
}

.search-width {
	width: 40%;
}
</style>
<style scoped>
.questionbank-header {
	display: flex;
	align-items: center;
}

.databank-card {
	border: none;
	display: flex;
	justify-content: center;
	margin-top: 15px;
	overflow: auto;
	margin-left: 10px;
	box-shadow: 1px 1px 3.5px 1px #d9d9d9;
}

.form-control:focus {
	border-color: inherit;
	-webkit-box-shadow: none;
	box-shadow: none;
}

.icon-dos {
	display: flex;
	border-radius: 20px;
	align-items: center;
}

.search-icon {
	position: absolute;
	padding-left: 0.7rem;
	z-index: 1;
	color: #a2a2a2;
}

.search-con {
	border-radius: 20px;
	background-color: transparent;
	border-color: #e6e6e6;
	color: #a2a2a2;
	position: relative;
	padding-left: 2rem;
}

.databank-title {
	margin-left: -4px;
	font-size: 18px;
	font-weight: 500px;
	margin-top: 10px;
	color: #4b4d4e;
}

.icon-image {
	position: absolute;
	margin-top: 7px;
	margin-left: 10px;
	z-index: 1;
	color: #4b4d4e !important;
}

.sort-dropdown {
	position: relative;
}

.dropdown {
	padding-left: 1.7rem;
	width: 100px;
	height: 32px !important;
	border: 1px solid #dee2e6;
	background-color: #ffffff;
}

.dropdown:hover {
	color: #4b4d4e;
	background-color: #ffffff;
}

.dropdown:focus,
.dropdown.focus {
	border: 1px solid #a2a2a2;
	color: #4b4d4e !important;
	background-color: #ffffff !important;
	box-shadow: 0 0 0 0 !important;
}

.sort-icon {
	margin-left: 0px;
}

.filter-icon {
	margin-left: 0.4rem;
}

.mostly-customized-scrollbar::-webkit-scrollbar-thumb {
	background: #cccccc;
	height: 27vh;
	width: 55vh;
	margin-left: -35px;
	margin-top: 15px;
	border-radius: 10px;
}

.mostly-customized-scrollbar::-webkit-scrollbar {
	width: 10px;
	height: 8px;
	background-color: #e4e4e4;
	box-shadow: inset 0 3px 5px #c9c9c9;
	border-radius: 10px;
}

.quest {
	max-height: 463px;
	overflow-y: auto;
	margin-bottom: 5px;
}

.search-ques {
	box-sizing: border-box;
	padding-left: 25px;
	padding-right: 30px;
	left: 102px;
	background: #ffffff;
	border: 0.5px solid #c4c4c4;
	box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.2);
	border-radius: 3px;
}

.db-ques-cards {
	background: #ffffff;
	box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
	border-radius: 10px;
	border: 1px #ffffff;
}

.db-ques-fullcards {
	background: #ffffff;
	box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
	border-radius: 10px;
	border: 1px #ffffff;
}
.dbquesfullcards {
	background: #ffffff;
	box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
	border-radius: 10px;
	border: 1px solid #ffffff;
}
.dbquescards {
	background: #ffffff;
	box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
	border-radius: 10px;
	border: 1px solid #ffffff;
}
.selquessubcontainer {
	background: #e8f0fe;
	border: 1px solid #3379b3;
	box-shadow: 2px 4px 12px rgb(0 0 0 / 8%);
	border-radius: 10px;
}

.sec-qb-text-view {
	font-size: 16px;
	font-weight: var(--weight-M);
	color: var(--bg-primary);
}
.sel-ques-sub-container {
	background: #e8f0fe;
	border: 1px solid #3379b3;
	box-shadow: 2px 4px 12px rgb(0 0 0 / 8%);
	border-radius: 10px;
}

.minimize-right {
	background: #ffffff;
	box-shadow: 0px 2px 11px rgba(0, 0, 0, 0.25);
	width: 34px;
	border-radius: 20px;
	height: 34px;
	display: flex;
	padding: 10px;
	align-items: center;
}
.Movebtn {
	margin-left: 70%;
}
</style>
